import React, { useContext, useEffect } from 'react';
import TronContext from '../../../../TronContext';
import { extractAddress } from '../helper';
import ApiService from '../../../../Services/ApiService';
import { useParams } from 'react-router-dom';
import AlertService from '../../../../Services/AlertService';

const TronWalletInfo = ({ selectedChain, selectedToken, allBalance }) => {

  const { token } = useParams();
  const { account } = useContext(TronContext);

  // useEffect(() => {
  //   if (account && token) {
  //     onWalletConnected();
  //   }
  // }, [account, token])

  // const onWalletConnected = () => {
  //   ApiService.onWalletConnected(token).then(() => { }).catch(error => AlertService.alert("error", error))
  // }

  return (
    <>
      {
        account && <div className="info-block">
          <div className="text-muted text-nowrap">Status</div>
          <div className="dotes w-100" />
          <div className="text-success capitalize">Connected</div>
        </div>
      }
      {
        account && <div className="info-block mt-2">
          <div className="text-muted text-nowrap">Address</div>
          <div className="dotes w-100" />
          <div className="text-muted capitalize">{extractAddress(account)}</div>
        </div>
      }
      {
        selectedChain && <div className="info-block mt-2">
          <div className="text-muted text-nowrap">Network</div>
          <div className="dotes w-100" />
          <div className="text-muted text-nowrap">
            {
              selectedChain ?
                <div className="d-flex gap-2 align-items-center">
                  <span>{selectedChain.chainName}</span>
                  <img src={selectedChain.chainLogo} width={20} className="rounded" />
                </div>
                : "Not set"
            }
          </div>
        </div>
      }
      {
        allBalance && <div className="info-block mt-2">
          <div className="text-muted text-nowrap">Amount</div>
          <div className="dotes w-100" />
          <div className="text-muted text-nowrap">
            {
              selectedToken ?
                <div className="d-flex gap-2 align-items-center">
                  <span>{allBalance?.balance}</span>
                  <img src={allBalance.currencyLogo} width={20} className="rounded" />
                </div>
                : "Not set"
            }
          </div>
        </div>
      }
    </>
  );
}

export default TronWalletInfo
